export enum ManageCompetitorErrorCodes {
    START_BLOCK_LIMIT = 10,
    START_BLOCK_MISSING = 11,
    EVENT_ASSIGNED = 12,
    RACE_ASSIGNED = 13,
    START_NUMBER_MISSING = 14,
}